
import { getLedgerDetails, getMasterData, getPatient, getPatientMasterTags } from './actions/index';
import React, { Component } from 'react';
import { change, Field, reduxForm, reset } from 'redux-form';
import {
  renderAutoCompleteMultipleSelection,
  renderAutoCompleteSingleSelect,
  renderDateField,
  renderCheckBox,
  renderTextField,
  isInteger
} from '../../../../components/reduxFields';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux';
// import PaginatorCustom from '../../../../components/paginationCustom';
import ClaimsDetail from './claims';
import ClaimServiceLines from './claimServiceLines';
// import GlobalVariables from './../../../../actions/utilAction';
import moment from 'moment';
import validate from './validate';

class Ledger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientId: null,
      PayerIds: null,
      PatientIds: null,
      PatientTags: null,
      ClaimPaymentStatus: null,
      viewClaimServiceLines: false,
      claimId: null,
      FromDate: new Date(),
      ToDate: new Date(),
      allClientTags: [],
      ShowClaimsWithNotesOnly: false,
      ShowClaimsWithoutNotesOnly: false,
      claimIdSearch: null,
      isExcludeTag: false,
      masterTagsAll: [],
      ServiceCodes: null,
      ServiceLocationTypeIds: null,
      accountRefSearch: null,
      ClaimOfficeallyStatusIds: null,
      isSearchBySubmittedDates: false,
    };

    this.filter = {
      sort_Column: 'claimId',
      sort_Order: 'desc',
    };

    this.handleViewClick = this.handleViewClick.bind(this);
    this.onBackClick = this.onBackClick.bind(this);

    this.onDateChange = this.onDateChange.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.loadClaimsData = this.loadClaimsData.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleNewRequestMultiSelect = this.handleNewRequestMultiSelect.bind(this);   
    this.checkBoxSearch = this.checkBoxSearch.bind(this);    
  }

  componentWillMount() {
    let masterData = { 'masterdata': 'MASTERINSURANCECOMPANY,MASTERTAGSFORPATIENT,CLAIMPAYMENTSTATUS,MASTERSERVICECODE,MASTERPATIENTLOCATION,CLAIMOFFICEALLYSTATUS' };
    this.props.getMasterData(masterData);
    // let searchTagObj = {
    //   filters: { TypeKey: 'ALL_CLIENT,BOTH' },
    // };
    // this.props.getPatientMasterTags(searchTagObj);
    let searchObj = {
      //locationIds: this.props.currentLocationId || '',
      locationIds: '0',
      isActiveCheckRequired: 'NO'
    };
    this.props.getPatient(searchObj);
    this.props.dispatch(change('LedgerForm', 'FromDate', this.state.FromDate));
    this.props.dispatch(change('LedgerForm', 'ToDate', this.state.ToDate));
    this.loadClaimsData();
  }

  loadClaimsData(page_number) {
    // console.log('this.state.PatientIds.............',this.state.PatientIds);
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'claimId',
      sort_order: this.filter.sort_Order || 'desc',
      contain_filters: {
        payerIds: this.state.PayerIds || null,
        patientIds: this.state.PatientIds || null,
        tags: this.state.PatientTags || null,
        fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
        claimBalanceStatus: this.state.ClaimPaymentStatus || null,
        showClaimsWithNotesOnly: this.state.ShowClaimsWithNotesOnly || "0",
        showClaimsWithoutNotesOnly: this.state.ShowClaimsWithoutNotesOnly || "0",
        claimId: this.state.claimIdSearch ? (Number.isInteger(this.state.claimIdSearch) ? 'CL' + this.state.claimIdSearch.toString().trim() : this.state.claimIdSearch.trim()) : null,
        isExcludeTag: this.state.isExcludeTag,
        serviceCodes: this.state.ServiceCodes ? this.state.ServiceCodes : '',
        serviceLocationTypeIds: this.state.ServiceLocationTypeIds ? this.state.ServiceLocationTypeIds : '',
        accountRefId: this.state.accountRefSearch || null,
        claimOfficeallyStatusIds: this.state.ClaimOfficeallyStatusIds ? this.state.ClaimOfficeallyStatusIds : '',
        searchBySubmittedDates: this.state.isSearchBySubmittedDates || "0",
      },
      pageNumber: page_number ? page_number : 1,
      pageSize: 50,
    };

    this.setState({
      searchObjForRefresh: searchObj
    });

    // console.log('searchObj.............', searchObj)
    this.props.getLedgerDetails(searchObj);
  }

  handleViewClick(e, obj) {
    this.setState({ patientId: obj.patientId, claimId: obj.claimId }
      , () => { this.setState({ viewClaimServiceLines: true }); });
  }

  onBackClick() {
    this.setState({ viewClaimServiceLines: false, claimId: null, patientId: null });
    this.props.dispatch(change('LedgerForm', 'PayerIds', this.state.PayerIds));
    this.props.dispatch(change('LedgerForm', 'PatientIds', this.state.PatientIds));
    this.props.dispatch(change('LedgerForm', 'PatientTags', this.state.PatientTags));
    this.props.dispatch(change('LedgerForm', 'ShowClaimsWithNotesOnly', this.state.ShowClaimsWithNotesOnly));
    this.props.dispatch(change('LedgerForm', 'ShowClaimsWithoutNotesOnly', this.state.ShowClaimsWithoutNotesOnly));
    this.props.dispatch(change('LedgerForm', 'isSearchBySubmittedDates', this.state.isSearchBySubmittedDates));    
    if (this.state.ClaimPaymentStatus === '0') {
      let paymentStatus = this.props.masterClaimPaymentStatus.filter((obj) => obj.globalCodeValue.toLowerCase() === 'no payment status').id;
      this.props.dispatch(change('LedgerForm', 'ClaimPaymentStatus', paymentStatus));
    }
    else {
      this.props.dispatch(change('LedgerForm', 'ClaimPaymentStatus', this.state.ClaimPaymentStatus));
    }
    let masterData = { 'masterdata': 'MASTERINSURANCECOMPANY,MASTERTAGSFORPATIENT,CLAIMPAYMENTSTATUS,CLAIMOFFICEALLYSTATUS' };
    this.props.getMasterData(masterData);
    this.loadClaimsData();
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;
      this.loadClaimsData();
    }
  }

  handleSearchChange(formData) {
    let IsNoPaymentStatus = false;
    if (formData.ClaimPaymentStatus && formData.ClaimPaymentStatus.length === 1) {
      IsNoPaymentStatus = this.props.masterClaimPaymentStatus.filter((obj) => obj.id === formData.ClaimPaymentStatus[0] && obj.globalCodeValue.toLowerCase() === 'no payment status').length > 0 ? true : false;
    }
    this.setState({
      PayerIds: formData.PayerIds ? formData.PayerIds : null,
      PatientIds: formData.PatientIds ? formData.PatientIds : null,
      PatientTags: formData.PatientTags ? formData.PatientTags : null,
      ClaimPaymentStatus: IsNoPaymentStatus ? '0' : formData.ClaimPaymentStatus ? formData.ClaimPaymentStatus : null,
    }, () => this.loadClaimsData());


    // if (event.target.value.length > 2) {
    //   this.filter.searchText = event.target.value;
    //   this.loadClaimsData();
    // } else if (event.target.value.length === 0) {
    //   this.filter.searchText = '';
    //   this.loadClaimsData();
    // }
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

  handleReset = () => {
    // this.props.dispatch(reset('LedgerForm'));
    this.props.dispatch(change('LedgerForm', 'ClaimID', null));
    this.props.dispatch(change('LedgerForm', 'PatientIds', null));
    this.props.dispatch(change('LedgerForm', 'PayerIds', null));
    this.props.dispatch(change('LedgerForm', 'PatientTags', null));
    this.props.dispatch(change('LedgerForm', 'ClaimPaymentStatus', null));
    this.props.dispatch(change('LedgerForm', 'ShowClaimsWithNotesOnly', false));
    this.props.dispatch(change('LedgerForm', 'ShowClaimsWithoutNotesOnly', false));
    this.props.dispatch(change('LedgerForm', 'AccountRefNumber', null));
    this.props.dispatch(change('LedgerForm', 'isSearchBySubmittedDates', false));    

    // resetFiltersAndSorting(this.filter, 'claimId', true);
    // this.setState({
    //   PayerIds: null,
    //   PatientIds: null,
    //   FromDate: null,
    //   ToDate: null,
    //   PatientTags: null,
    // }, () => {
    //   this.loadClaimsData();
    // });
    this.setState({
      PayerIds: null,
      PatientIds: null,
      PatientTags: null,
      ClaimPaymentStatus: null,
      claimIdSearch: null,
      claimId: null,
      FromDate: new Date(),
      ToDate: new Date(),
      ShowClaimsWithNotesOnly: false,
      ShowClaimsWithoutNotesOnly: false,
      isExcludeTag: false,
      masterTagsAll: [],
      ServiceLocationTypeIds: null,
      ClaimOfficeallyStatusIds: null,
    }, () => this.loadClaimsData());
  };

  handleNewRequest(input, selectedValue) {
    if (input.name === 'PayerIds') {
      input.onChange(selectedValue.value);
    }
    else if (input.name === 'PatientIds' || input.name === 'ClaimPaymentStatus') {
      input.onChange(selectedValue);
    }
  }

  handleNewRequestTags = (input, selectedValue) => {
    input.onChange(selectedValue);
    this.setState({
      masterTagsAll: selectedValue,
    }, () => {
      if (this.state.masterTagsAll.length === 0) {
        this.props.dispatch(reset('LedgerForm', "ExcludeTag", false))
        this.props.dispatch(change('LedgerForm', 'FromDate', this.state.FromDate));
        this.props.dispatch(change('LedgerForm', 'ToDate', this.state.ToDate));
      }
    });
  }

  handleAdvanceFilterCheck = (input, name) => {
    if (name === 'ShowClaimsWithNotesOnly' && input.target.checked) {
      this.props.dispatch(change('LedgerForm', 'ShowClaimsWithoutNotesOnly', false));
      this.setState({ ShowClaimsWithoutNotesOnly: false });
    } else if (name === 'ShowClaimsWithoutNotesOnly' && input.target.checked) {
      this.props.dispatch(change('LedgerForm', 'ShowClaimsWithNotesOnly', false));
      this.setState({ ShowClaimsWithNotesOnly: false });
    }

    this.setState({ [name]: input.target.checked },
      () => {
        this.loadClaimsData();
      });
  }

  claimIdHandler = (event) => {
    this.setState({
      claimIdSearch: event.target.value
    });
  }

  accountRefSearchHandler = (event) => {
    this.setState({
      accountRefSearch: event.target.value
    });
  }
  

  isExcludeTagHandler = (e) => {
    this.setState({
      isExcludeTag: !this.state.isExcludeTag
    });
  }

  handleNewRequestMultiSelect(input, selectedValues) {
    input.onChange(selectedValues);    
    if(input.name === 'MasterServiceCode')
    {     
      this.setState({
        ServiceCodes: selectedValues,
      });
    }
    else if(input.name === 'ServiceLocationTypeIds')
    {      
      this.setState({
        ServiceLocationTypeIds: selectedValues,
      });
    }
    else if(input.name === 'ClaimOfficeallyStatus')
    {      
      this.setState({
        ClaimOfficeallyStatusIds: selectedValues,
      });
    }
  }

  checkBoxSearch = (e, name) => {
    if (name === 'isSearchBySubmittedDates') {
      if(e.target.checked) 
      {
        this.setState({isSearchBySubmittedDates : true});       
      }
      else
      {
        this.setState({isSearchBySubmittedDates : false});
      }
    }    
  }

  render() {
    const { handleSubmit } = this.props;

    let claimledgerDetails = null;
    if (this.state.PatientIds && this.state.FromDate && this.state.ToDate) {
      claimledgerDetails = this.props.ledgerDetails;
    }

    return (
      <div>
        {/* {this.state.open ? <AppointmentTypeModal open={this.state.open} closeDialog={this.handleClose} appointmentTypeObj={this.state.appointmentTypeObj} /> : ''} */}
        <h2 className="page_title">Manage Ledger</h2>

        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            {!this.state.viewClaimServiceLines ?
              <form className="readmin-form custom_form">
                <div className="row mtm-20">
                  <div className="col-sm-4 mt-8">
                    <Field
                      autoFocus={true}
                      name="ClaimID"
                      floatingLabelText="Claim ID"
                      onChange={(e) => this.claimIdHandler(e)}
                      component={renderTextField} />
                  </div>
                  <div className="col-sm-4 insfield ">
                    <Field
                      name="PayerIds"
                      label="Insurance Company"
                      handleNewRequest={this.handleNewRequest}
                      options={this.props.masterInsuranceCompanies}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                  <div className="col-sm-4 insfield">
                    <Field
                      name="PatientIds"
                      label="Client Name"
                      handleNewRequest={this.handleNewRequest}
                      options={this.props.patientList}
                      component={renderAutoCompleteMultipleSelection} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 insfield ">
                    <Field
                      name="ClaimPaymentStatus"
                      label="Payment Status"
                      handleNewRequest={this.handleNewRequest}
                      options={this.props.masterClaimPaymentStatus}
                      component={renderAutoCompleteMultipleSelection}
                    />
                  </div>
                  <div className="col-sm-4 mt-8">
                    <Field name="FromDate"
                      placeholder="Start Date"
                      locale="en-US"
                      selected={this.state.FromDate}
                      onDateChange={this.onDateChange}
                      openToYearSelection={true}
                      component={renderDateField} />
                  </div>
                  <div className="col-sm-4 mt-8">
                    <Field name="ToDate"
                      placeholder="End Date"
                      locale="en-US"
                      // minDate = {FromDate || new Date()}
                      selected={this.state.ToDate}
                      onDateChange={this.onDateChange}
                      openToYearSelection={true}
                      component={renderDateField} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 insfield mt-35">
                    <Field
                      name="MasterServiceCode"
                      label="Service Code"
                      handleNewRequest={this.handleNewRequestMultiSelect}
                      options={this.props.masterServiceCode}
                      component={renderAutoCompleteMultipleSelection} />
                  </div>
                  <div className="col-sm-4 insfield ">
                    <Field
                      name="PatientTags"
                      label="Tags"
                      handleNewRequest={this.handleNewRequestTags}
                      options={this.props.masterTags}
                      component={renderAutoCompleteMultipleSelection} />
                  </div>
                  <div className="col-sm-4 insfield ">
                    {this.state.masterTagsAll.length > 0 && <Field
                      name="ExcludeTag"
                      label="Exclude Tag"
                      component={renderCheckBox}
                      onChange={(e) => this.isExcludeTagHandler(e)}
                    />}
                  </div>
                </div>
                <div className='row'>
                  <div className="col-sm-4 insfield mt-35">
                    <Field
                      name="ServiceLocationTypeIds"
                      label="Service Location Type"
                      handleNewRequest={this.handleNewRequestMultiSelect}
                      options={this.props.masterPatientLocation}
                      component={renderAutoCompleteMultipleSelection} />
                  </div>
                  <div className="col-sm-3 mt-30">
                    <Field
                      name="ShowClaimsWithNotesOnly"
                      label="Show Claims With Notes Only"
                      component={renderCheckBox}
                      onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowClaimsWithNotesOnly')}
                    />
                  </div>
                  <div className="col-sm-3 mt-30">
                    <Field
                      name="ShowClaimsWithoutNotesOnly"
                      label="Show Claims Without Notes Only"
                      component={renderCheckBox}
                      onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowClaimsWithoutNotesOnly')}
                    />
                  </div>
                </div>  
                <div className='row'>
                  <div className="col-sm-4 mt-8">
                    <Field                      
                      name="AccountRefNumber"
                      label="Clearinghouse Acct #"
                      maxLength="10"
                      normalize={isInteger}
                      onChange={(e) => this.accountRefSearchHandler(e)}
                      component={renderTextField} />
                  </div>
                  <div className="col-sm-4 mt-35">
                    <Field
                        name="ClaimOfficeallyStatus"
                        label="Claim Clearinghouse Status"
                        handleNewRequest={this.handleNewRequestMultiSelect}
                        options={this.props.masterClaimOfficeallyStatus}
                        component={renderAutoCompleteMultipleSelection}
                      />
                  </div>
                  <div className="col-sm-3 mt-30">
                    <Field
                       className="mt25"
                       name="isSearchBySubmittedDates"
                       label="Search by Claim Submitted Dates"
                       onChange={(e) => this.checkBoxSearch(e, 'isSearchBySubmittedDates')}
                       component={renderCheckBox}
                    />
                  </div>
                </div>  
                <div className='row'>
                  <div className="col-sm-8"></div>  
                  <div className="col-sm-4 btn_rt reset-btn">
                    <RaisedButton className="grey_btn" onTouchTap={handleSubmit(this.handleSearchChange)} primary={true}>Filter</RaisedButton>
                    <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                  </div>
                </div>
                <div className='row mt-10'>
                  <div className="col-sm-4">
                      <p>
                        <b>Total Allowed Balance : </b> <span>{this.props.ledgerDetails && this.props.ledgerDetails.data && this.props.ledgerDetails.data.length > 0 && this.props.ledgerDetails.data[0].totalAllowedAmount ? this.props.ledgerDetails.data[0].totalAllowedAmount.toFixed(2).toString() : '0.00'}</span>
                      </p>
                  </div>  
                  <div className="col-sm-4">
                      <p>
                        <b>Total Balance Without Adjustment : </b> <span>{this.props.ledgerDetails && this.props.ledgerDetails.data && this.props.ledgerDetails.data.length > 0 && this.props.ledgerDetails.data[0].totalBalanceWithoutAdjustment ? this.props.ledgerDetails.data[0].totalBalanceWithoutAdjustment.toFixed(2).toString() : '0.00'}</span>
                      </p>
                  </div>  
                  <div className="col-sm-4">
                      <p>
                        <b>Total  Balance With Adjustment : </b> <span>{this.props.ledgerDetails && this.props.ledgerDetails.data && this.props.ledgerDetails.data.length > 0 && this.props.ledgerDetails.data[0].totalBalanceWithAdjustment ? this.props.ledgerDetails.data[0].totalBalanceWithAdjustment.toFixed(2).toString() : '0.00'}</span>
                      </p>
                  </div>                   
                </div>
              </form>

              : null}
            <div className="row">
              <div className="col-sm-12">
                {!this.state.viewClaimServiceLines ?
                  <ClaimsDetail
                    ledgerDetails={claimledgerDetails}
                    handleViewClick={this.handleViewClick}
                    masterClaimPaymentStatus={this.props.masterClaimPaymentStatus}
                    setSortColumn={this.setSortColumn}
                    loadClaimsData={this.loadClaimsData}
                    handleReset={this.handleReset}
                    searchObj={this.state.searchObjForRefresh}
                  // {...this.props}
                  />
                  : <ClaimServiceLines
                    patientId={this.state.patientId}
                    claimId={this.state.claimId}
                    onBackClick={this.onBackClick}
                  />}
                {/* <Paginator data={this.props.get_appointment_type_data.meta} handlePageChange={(page_number) => this.loadClaimsData(page_number)} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Ledger = reduxForm({
  form: 'LedgerForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(Ledger);

function mapStateToProps(state) {
  let masterInsuranceCompanies = [], patients = [], masterTagsforPatient = [];
  let masterServiceCode = [],  masterPatientLocation = [];
  // console.log('state.ledger..................', state.ledger)
  if (state.ledger.masterData && state.ledger.masterData.insuranceCompanies) {
    masterInsuranceCompanies = state.ledger.masterData.insuranceCompanies;
  }
  if (state.ledger.masterData && state.ledger.masterData.masterTagsforPatient) {
    masterTagsforPatient = state.ledger.masterData.masterTagsforPatient;
  }

  if (state.ledger.patientList && state.ledger.patientList.data) {
    patients = state.ledger.patientList.data.patients;
  }

  if (state.ledger.masterData && state.ledger.masterData.masterServiceCode) {
    masterServiceCode = state.ledger.masterData.masterServiceCode || [];
  }

  if (state.ledger.masterData && state.ledger.masterData.masterPatientLocation) {
    masterPatientLocation = state.ledger.masterData.masterPatientLocation || [];
  }

  return {
    masterInsuranceCompanies: masterInsuranceCompanies || [],
    patientList: patients,
    masterTags: masterTagsforPatient || [],
    currentLocationId: state.login.currentLocationId,
    ledgerDetails: state.ledger.ledgerDetails,
    masterClaimPaymentStatus: (state.ledger.masterData && state.ledger.masterData.claimPaymentStatus) || [],
    masterServiceCode: masterServiceCode,
    masterPatientLocation: masterPatientLocation,
    masterClaimOfficeallyStatus: (state.ledger.masterData && state.ledger.masterData.claimOfficeallyStatus) || [],
    // addPermission: addPermission,
    // updatePermission: updatePermission,
    // deletePermission: deletePermission,
  };
}

export default connect(mapStateToProps, { getLedgerDetails, getMasterData, getPatient, getPatientMasterTags })(Ledger);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/Ledger/index.js